export const cardsData = [
  {
      "Project.Title": "Project 1",
      "Project.Technologies": ["Python", "HTML", "CSS", "Machine Learning", "Deep Learning"],
      "Technical_Skillset.Frontend": ["HTML", "CSS", "JavaScript"],
      "Technical_Skillset.Backend": ["Python"],
      "Technical_Skillset.Databases": [],
      "Technical_Skillset.Infrastructure": [],
      "Other_Information.Availability": "Available to join immediately"
  },
  {
      "Project.Title": "Project 2",
      "Project.Technologies": ["Java Spring Boot", "Hibernate", "MySQL"],
      "Technical_Skillset.Frontend": ["React JS"],
      "Technical_Skillset.Backend": ["Java", "Spring Boot", "Hibernate"],
      "Technical_Skillset.Databases": ["MySQL"],
      "Technical_Skillset.Infrastructure": [],
      "Other_Information.Availability": "Available to join within a week and open to relocate to Gurgaon"
  },
  {
      "Project.Title": "Project 3",
      "Project.Technologies": ["Java", "HTML", "CSS", "JavaScript"],
      "Technical_Skillset.Frontend": ["React", "HTML", "CSS"],
      "Technical_Skillset.Backend": ["Java", "Python Django", "Flask"],
      "Technical_Skillset.Databases": ["MySQL", "MongoDB", "Postgres"],
      "Technical_Skillset.Infrastructure": ["AWS", "Azure OCR", "Apache", "Docker"],
      "Other_Information.Availability": "Available to join immediately and willing to relocate to Gurgaon"
  },
  {
      "Project.Title": "Project 4",
      "Project.Technologies": ["Websockets", "Redis", "Channel layers"],
      "Technical_Skillset.Frontend": ["React"],
      "Technical_Skillset.Backend": ["Python Django", "Django Rest"],
      "Technical_Skillset.Databases": ["MySQL"],
      "Technical_Skillset.Infrastructure": [],
      "Other_Information.Availability": "Immediate or first/last week of October"
  },
  {
      "Project.Title": "Project 5",
      "Project.Technologies": ["Python", "Scrapy framework", "MongoDB"],
      "Technical_Skillset.Frontend": ["React Native"],
      "Technical_Skillset.Backend": ["Python", "Django"],
      "Technical_Skillset.Databases": ["MongoDB"],
      "Technical_Skillset.Infrastructure": [],
      "Other_Information.Availability": "15-20 days, and is willing to relocate to Gurgaon"
  },
  {
      "Project.Title": "Project 6",
      "Project.Technologies": ["Postman", "Docker", "Jenkins", "Java", "Spring Boot"],
      "Technical_Skillset.Frontend": ["React", "Angular"],
      "Technical_Skillset.Backend": ["Spring Boot", "Java"],
      "Technical_Skillset.Databases": [],
      "Technical_Skillset.Infrastructure": ["Postman", "Docker", "Jenkins"],
      "Other_Information.Availability": "Available to join in 10-15 days and willing to work from Gurgaon office."
  },
  {
      "Project.Title": "Project 7",
      "Project.Technologies": ["React JS", "JWT Authentication", "Local Storage"],
      "Technical_Skillset.Frontend": ["React JS", "HTML", "CSS", "JavaScript"],
      "Technical_Skillset.Backend": ["Node JS"],
      "Technical_Skillset.Databases": ["MongoDB"],
      "Technical_Skillset.Infrastructure": [],
      "Other_Information.Availability": "Available to join immediately, comfortable with relocating to Gurgaon"
  },
  {
      "Project.Title": "Project 8",
      "Project.Technologies": ["Python", "Django", "API"],
      "Technical_Skillset.Frontend": ["No experience"],
      "Technical_Skillset.Backend": ["Python Django", "API"],
      "Technical_Skillset.Databases": [],
      "Technical_Skillset.Infrastructure": [],
      "Other_Information.Availability": "Immediate"
  },
  {
      "Project.Title": "Project 9",
      "Project.Technologies": ["React", "Node", "Java"],
      "Technical_Skillset.Frontend": ["React", "Java", "Angular", "Node", "JavaScript"],
      "Technical_Skillset.Backend": ["Node"],
      "Technical_Skillset.Databases": ["SQL"],
      "Technical_Skillset.Infrastructure": [],
      "Other_Information.Availability": "Can join within one week; Comfortable with working from the office in Gurgaon"
  },
  {
      "Project.Title": "Project 10",
      "Project.Technologies": ["React JS", "Redux", "HTML", "CSS", "Bootstrap", "Material UI", "Socket.io", "Python Django"],
      "Technical_Skillset.Frontend": ["React JS", "HTML", "CSS", "Bootstrap", "Material UI"],
      "Technical_Skillset.Backend": ["Python Django"],
      "Technical_Skillset.Databases": [],
      "Technical_Skillset.Infrastructure": [],
      "Other_Information.Availability": "Available to join within 30 days, comfortable working from office in Gurgaon"
  }
];


export const clientID  = "680681562641-fdgvc2cbpiebs1gir3od3u2e1mvhgn56.apps.googleusercontent.com";

export const clientSecret = "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";

export const PALM_API_KEY = "AIzaSyBDHVwchdOiVkFnmko6lZx8Q_RInWQntQM";

export const btn_style_if_admin = {
  backgroundColor : "white",
        border: "none",
        padding: "10px 20px",
        borderRadius: "5px",
        cursor: "pointer",
      }
export const btn_style_if_not_admin = {
  backgroundColor : "white",
        border: "none",
        padding: "10px 20px",
        borderRadius: "5px",
        cursor: "pointer",
        visibility: "hidden",
}